<script lang="ts">
  import type { RichTextFieldComponentProps } from './types';
  import DynamicChildrenComponent from '$lib/components/DynamicChildrenComponent/DynamicChildrenComponent.svelte';

  export let body: RichTextFieldComponentProps['body'];
  export let entryId: RichTextFieldComponentProps['entryId'];
  export let customCssClass: RichTextFieldComponentProps['customCssClass'];
</script>

<div
  class="RichTextFieldComponent RichTextFieldComponent-{entryId}-box-properties {customCssClass}"
  data-entry-id={entryId}
>
  {#if body}
    <DynamicChildrenComponent children={body} />
  {/if}
</div>
